import { whoAmIReducer, WhoAmIState } from '@grid-ui/whoami';
import { ActionReducerMap } from '@ngrx/store';
export interface AppState {
  whoAmI: WhoAmIState;
}

export const coreReducers: ActionReducerMap<AppState> = {
  whoAmI: whoAmIReducer,
};
